export enum AlertStatus {
  Received = 1,
  OnHold = 2,
  InAnalysis = 3,
  Closed = 4,
  Rejected = 5
}
